import { render, staticRenderFns } from "./CompanyDetailsAccountManagement.vue?vue&type=template&id=2485b8a8&"
import script from "./CompanyDetailsAccountManagement.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsAccountManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports